<template>
  <FullScreenPopup
    ref="popup"
    title="Інформація про завдання"
    :lock-scroll="true"
    @visibility-change="handleVisibilityChange"
    @default-selected="task.status === 'new' ? $emit('task-mark-as-finished') : $emit('task-mark-as-active')"
  >
    <div class="task-info-popup">
      <PopupSubtitle>{{ task.name }}</PopupSubtitle>
      <div class="task-info-popup__description" v-html="formatBasicText(task.description)"></div>

      <PopupSubtitle v-if="isTaskHasAttachment">Файли завдання</PopupSubtitle>
      <FilesList
        v-if="isTaskHasAttachment"
        :files="task.attachments"
        :download-link-generator="generateDownloadLink"
      />

      <div v-if="isTaskEditable" class="task-info-popup__controls-wrapper">
        <Divider type="horizontal" />
        <div class="task-info-popup__controls">
          <BlueButton
            v-if="task.status === 'new' && isTaskEditable"
            class="task-info-popup__finished task-info-popup__button mr-2"
            size="small"
            :is-loading="controls.processing"
            @click="$emit('task-mark-as-finished')"
          >
            Позначити як виконане
          </BlueButton>
          <BlueButton
            v-if="task.status === 'finished' && isTaskEditable"
            class="task-info-popup__active task-info-popup__button mr-2"
            size="small"
            :is-loading="controls.processing"
            @click="$emit('task-mark-as-active')"
          >
            Позначити як активне
          </BlueButton>
          <WhiteButton
            v-if="task.status === 'new'"
            class="task-info-popup__edit task-info-popup__button mr-2"
            @click="$emit('task-edit', task)"
          >
            Редагувати
          </WhiteButton>
          <WhiteButton
            v-if="task.status === 'new'"
            class="task-info-popup__delete task-info-popup__button"
            @click="$emit('task-delete', task)"
          >
            Видалити
          </WhiteButton>
        </div>
      </div>
    </div>
  </FullScreenPopup>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { taskAttachmentDownloadLinkGenerator } from '@/features/tasks/lib';
import { basicFormatter } from '@/shared/lib/string';
import { Divider } from '@/shared/ui/divider';
import { FilesList } from '@/shared/ui/file-upload';
import { BlueButton, WhiteButton } from '@/shared/ui/form';
import { PopupSubtitle } from '@/shared/ui/full-screen-popup';
import { FullScreenPopup } from '@/shared/ui/popup';

export default {
  data() {
    return {
      task: {
        id: '',
        name: '',
        description: '',
        finishDate: '',
        attachments: [],
      },
      controls: {
        processing: false,
      },
    };
  },
  mixins: [ basicFormatter, taskAttachmentDownloadLinkGenerator ],
  components: { FullScreenPopup, PopupSubtitle, WhiteButton, BlueButton, Divider, FilesList },
  computed: {
    ...mapGetters('currentUserModule', ['getCurrentUserId']),
    isTaskEditable() {
      return this.task.user_id === this.getCurrentUserId
        && ((this.task?.finishDate && moment(this.task?.finishDate) >= moment().startOf('day'))
        || (this.task?.finish_date && moment(this.task?.finish_date) >= moment().startOf('day')));
    },
    isTaskHasAttachment() { return this.task?.attachments?.length || false; },
    getTask() { return this.task; },
  },
  methods: {
    open(task) {
      if (task) {
        this.task = task;
      }
      this.controls.isProcessing = false;

      this.$refs.popup.open();
    },
    togglePopup() {
      this.$refs.popup.togglePopup();
    },
    close() {
      this.$refs.popup.close();
    },
    setProcessing(processing = true) {
      this.controls.isProcessing = processing;
    },
    handleVisibilityChange({ id, isVisible }) {
      if (id === this.$refs.popup.getPopupId) {
        this.$emit('visibility-change', { id, isVisible });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.task-info-popup {
  max-width: 600px;

  &__description {
    max-height: 500px;
    padding-right: 15px;
    text-align: justify;
    overflow-y: scroll;
    margin-bottom: 20px;

    ::v-deep p {
      margin-bottom: 5px;
    }

    ::v-deep ul {
      list-style: disc;
      padding-left: 20px;
      margin-bottom: 10px;
    }

    ::v-deep ol {
      list-style: decimal;
      padding-left: 20px;
      margin-bottom: 10px;
    }

    ::v-deep li {
      margin-bottom: 4px;
    }
  }

  &__controls {
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 550px) {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 550px) {
    &__button {
      margin-bottom: 8px;
    }
  }
}
</style>
